import { has } from 'lodash';

export function currencyComparator(valueA, valueB) {
  const hasIntValue = has(valueA, 'intValue') && has(valueB, 'intValue');

  if (hasIntValue) {
    return valueA.intValue - valueB.intValue;
  }

  return valueA - valueB;
}

export function dateTimeComparator(valueA, valueB) {
  const dateA = new Date(valueA);
  const dateB = new Date(valueB);

  return dateA - dateB;
}
